/**
 * @description create pics model
 * @date 2019-05-06
 * @author jywang
 */
import React, { PureComponent } from 'react';
import { WithBaiduMediaUpload } from '../../components/HOC/BaiduMediaUpload';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import Arr from '@util/array';
import tool from '@util/tool';
import toast from '@util/toast';
import { Input, Button } from 'antd';
import { toJS } from 'mobx';
import './index.scss';
import Group from '../../components/Group';
import ScheduledPublishTime from '../../components/ScheduledPublishTime';
import moment from 'moment';
const { TextArea } = Input;

let currentEditPicId: any;
@inject('store')
@WithBaiduMediaUpload(inject('store'))
@observer
class CreatePics extends React.Component<any, any> {
    public imgList: any = [];
    constructor(props) {
        super(props);
        this.init();
        this.state = {
            releaseType: 1,
            releaseTime: ''
        };
    }
    public init = () => {
        const params = new URLSearchParams(window.location.search);
        const groupId = params.get('groupId');
        this.state = {
            imgList: [],
            hasClickSubmit: false,
            groupId: groupId || ''
        };
        const id = tool.getQueryString('id');
        if (id) {
            currentEditPicId = id;
            this.getDetail(id);
        }
    };
    public getIdFromURL = (url= window.location.href) => {
        const parsedUrl = new URL(url);
        return parsedUrl.searchParams.get('id') || '';
    }
    public render() {
        const { errorStatus, errorContent, store } = this.props;
        const { hasClickSubmit } = this.state;
        return (
            <div className="create-pics-box">
                <div>
                    <div className="pics-title">
                        <span className="iconfont">标题</span>
                        <Input
                            placeholder="请输入标题最多20字"
                            onChange={this.titleDescInputChange}
                            name="title"
                            value={store.addPics.title}
                            maxLength={20}
                        />
                    </div>
                </div>
                <div className="pics-title-box">
                    <span className="iconfont">内容</span>
                    <div className="pics-title-input-box">
                        <TextArea
                            rows={11}
                            autosize={false}
                            maxLength={10000}
                            onChange={this.titleDescInputChange}
                            name="content"
                            placeholder="一起聊聊吧"
                            value={store.addPics.content}
                        />
                    </div>
                </div>
                <div className="add-media-box">
                    <div className="add-img-box">
                        <p className="add-media-title">添加图片</p>
                        <ul>
                            {store.addPics.images &&
                                store.addPics.images.map((item, idx) => {
                                    return (
                                        <li key={idx}>
                                            <img src={item.url} alt="" />
                                            {
                                                // tslint:disable-next-line: jsx-no-lambda
                                                <span
                                                    className="imgClose"
                                                    onClick={() =>
                                                        this.delImg(idx)
                                                    }></span>
                                            }
                                        </li>
                                    );
                                })}
                            {store.addPics.images.length < 20 && <li className="add-img-input">
                                <input
                                    type="file"
                                    onChange={this.imgInputChange}
                                    name="question-img"
                                    id="question-img"
                                    value=""
                                    multiple={true}
                                    accept="image/jpg,image/jpeg,image/png,image/gif"
                                />
                                <span className="iconfont">&#xe71d;</span>
                            </li>}
                        </ul>
                    </div>
                    <div>
                    <div className="add-media-title" style={{marginBottom: 0}}>圈子</div>
                        <Group disabled={this.getIdFromURL()} value={this.state.groupId} onChange={(val) => {
                            this.setState({groupId: val});
                        }}></Group>
                    </div>
                    <br />
                    <ScheduledPublishTime
                      releaseType={this.state.releaseType}
                      releaseTime={this.state.releaseTime}
                      releaseTimeChange={(releaseTime) => {
                        this.setState({
                            releaseTime
                        });
                      }}
                      releaseTypeChange={
                        (releaseType) => {
                            this.setState({
                                releaseType
                            });
                        }
                      }

                  />
                </div>
                <div className="pics-publish-button-box">
                    <Button
                        disabled={hasClickSubmit}
                        onClick={this.submitBtn}
                        type="primary">
                        发帖
                    </Button>
                </div>
                <div className="bigScreen" hidden={errorStatus}>
                    <div className="errInfo">{errorContent}</div>
                </div>
            </div>
        );
    }
    public getDetail = id => {
        this.props.store.getDetail
            .get(id)
            .then(res => {
                if (res.group.groupId) {
                    this.setState({groupId: `${res.group.groupId}`});
                }
                if (res.releaseTime) {
                    this.setState({
                        releaseTime: res.releaseTime,
                        releaseType: 1
                    });
                } else {
                    this.setState({
                        releaseType: 1
                    });
                }
                const { store } = this.props;
                this.imgList = res.images.map(item => {
                    return { url: item.imageUrl, imageRes: item.imageRes };
                });
                store.addPics.set({ content: res.description });
                store.addPics.set({ images: this.imgList });
                store.addPics.set({ title: res.title });
            })
            .catch(err => {});
    };
    public delImg = number => {
        const { store } = this.props;
        const images =
            store.addPics.images &&
            store.addPics.images.filter((item, idx) => {
                return idx !== number;
            });
        const param: any = {};
        param.images = images;
        this.imgList = images;
        store.addPics.set(param);
    };
    public titleDescInputChange = e => {
        const name = e.target.name;
        const { store } = this.props;
        const param: any = {};
        param[name] = e.target.value;
        store.addPics.set(param);
    };

    public imgInputChange = e => {
        const files = e.target.files;
        const { store } = this.props;
        Arr.arrForEach(files, file => {
            if (this.imgList.length < 50) {
                this.props.getStsWrite(file, data => {
                    if (this.imgList.length < 50) {
                        const imgInfo: any = {};
                        if (data.url) {
                            imgInfo.url = data.url;
                            imgInfo.imageRes = data.pixel;
                            this.imgList.push(imgInfo);
                            const param: any = {};
                            param.images = this.imgList;
                            store.addPics.set(param);
                        } else {
                            // alert('图片上传失败');
                            toast.error('图片上传失败');
                        }
                    } else {
                        toast.error('只能上传50张图片');
                    }
                });
            } else {
                toast.error('只能上传50张图片');
            }
        });
    };
    public submitBtn = () => {
        this.setState({
            hasClickSubmit: true
        });
        const { store } = this.props;
        const { releaseTime } = this.state;
        const param_box: any = {};
        const param: any = {};
        if (releaseTime) {
             if (moment(releaseTime).valueOf() < Date.now()) {
                 toast.error('仅支持选择此刻之后14天时间');
                 this.setState({
                     hasClickSubmit: false
                 });
                 return;
             }
             param.releaseTime = releaseTime;

        }
        const content =
            store.addPics.content && store.addPics.content.replace(/\s+/g, '');
        if (!content && store.addPics.images.length <= 0) {
            toast.error('内容与图片必须填写一个');
            this.setState({
                hasClickSubmit: false
            });
            return;
        }
        if (store.addPics.content && store.addPics.content.length > 10000) {
            toast.error('图文内容不可超过10000个字');
            this.setState({
                hasClickSubmit: false
            });
            return;
        }
        if (store.addPics.title && store.addPics.title.length > 20) {
            toast.error('标题最多输入20字哦~');
            this.setState({
                hasClickSubmit: false
            });
            return;
        }
        if (store.addPics.images && store.addPics.images.length > 20) {
            toast.error('最多选择20张图片哦~');
            this.setState({
                hasClickSubmit: false
            });
            return;
        }
        param.content = tool.trimStr(store.addPics.content);
        param.images = toJS(store.addPics.images);
        param.groupId = this.state.groupId;
        param.title = store.addPics.title;

        // 处理bos图片签名
        for (const item of param.images) {
          if (item.url) {
            item.url = tool.removeQueryFromHtml(item.url);
          }
        }
        param_box.pic = param;
        if (currentEditPicId) {
            store.addPics
                .edit_v2_request({
                    post: param_box,
                    productId: currentEditPicId
                })
                .then(res => {
                    window.location.href = '/pics';
                })
                .catch(err => {
                    toast.error(err.msg);
                });
        } else {
            store.addPics
                .set_v2_request({ post: param_box })
                .then(res => {
                    window.location.href = '/pics';
                })
                .catch(err => {
                    toast.error(err.msg);
                    this.setState({
                        hasClickSubmit: false
                    });
                });
        }
    };
}
export default CreatePics;
